<template>
    <v-list-item style="border-bottom: 1px solid #cccc;" :prepend-icon="getArticleTypeIcon(article.ArticleType)"
        :subtitle="article.ArticleNumber" :title="article.ArticleDescription" link @click="$emit('click')">
    </v-list-item>
</template>


<script>
export default {
    name: 'ArticleListItem',
    props: {
        article: Object,
        getArticleTypeIcon: Function,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>